import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /first-500/* children (success, cancel) render through here.
// The landing page itself lives at ./first-500/index.tsx ("/first-500/").
export const Route = createFileRoute("/first-500")({
  component: () => <Outlet />,
});
